<template>
  <div class="s-layout">
    <div class="s-container">
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>

export default {
}
</script>

<style lang="scss" scoped>

@import "../../../../../assets/css/liff/main.css";
@import "../../../../../assets/css/liff/liff_init_theme_config.css";

.page {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  max-width: 750px;
}

</style>
